import React from 'react';
import './XrayButton.scss';
import axios from 'axios'
import fileDownload from 'js-file-download'
import SystemConfiguration from 'settings/SystemConfiguration';
import Images from 'constants/Images';
import * as THREE from 'three';
import { Material } from 'three';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader } from "@react-three/fiber";

function XrayButton(props) {

    function handleClick() {
        if(SystemConfiguration.material != null){
            if(!Array.isArray(SystemConfiguration.material)){
                if(SystemConfiguration.xrayEnabled) {
                    disableXray(SystemConfiguration.material)
                } else {
                    enableXray(SystemConfiguration.material, SystemConfiguration.mtl_file)
                }
            } else {
                // console.log(SystemConfiguration.material)
                for(var i = 0; i < SystemConfiguration.material.length; i++){
                    
                    if(SystemConfiguration.xrayEnabled) {
                        disableXray(SystemConfiguration.material[i])
                    } else {
                        enableXray(SystemConfiguration.material[i], SystemConfiguration.mtl_file)
                    }
                }
            }

            SystemConfiguration.xrayEnabled = !SystemConfiguration.xrayEnabled
        }
    }

    function disableXray(material) {
        material.transparent = false
        material.opacity = 1.0
        material.side = THREE.FrontSide
        console.log(material)
       // material.color = {r: 0.1, g: 0.1, b: 0.1}
        //material.map.dispose()
        //material.map = material.map_null//new THREE.TextureLoader().load(window.location.href + "/assets/template_texture.png");//SystemConfiguration.template_texture
        //material.map.needsUpdate = true
        material.needsUpdate = true
    }

    function enableXray(material, mtl_file) {
        material.transparent = true
        material.opacity = 0.5
        material.side = THREE.DoubleSide
        console.log(material)
        //material.map = material.map_temp
        // material.map.encoding = 3001 // after retexturing this value is set to 3000 which makes the texture too bright
        //material.color = {r: 1.0, g: 1.0, b: 1.0}
        material.needsUpdate = true
    }


    return (
        <img id="xraybutton" src={process.env.PUBLIC_URL + Images.button_xray} onClick={() => handleClick()}/>
    );

}

export default XrayButton;